import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

const routes=[
    {
        path:'/home',
        name: 'Home',
        component:()=>import('@/Home.vue')
    },
    {
        path:'',
        name: 'default',
        component:()=>import('@/Home.vue')
    },
    
    {
        path: '/radiation/radiationlist',
        name: 'Radiation Divice List',
        component: () => import('@/components/Radiation/RadiationList.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        path:'/radiation/newradiation',
        name:'New Radiation',
        component: ()=>import('@/components/Radiation/NewRadiation.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        path:'/radiation/updateradiation/:radiationId',
        name:'Update Radiation',
        component: () => import('@/components/Radiation/UpdateRadiation.vue'),
        props(route) {
            const props = { ...route.params }
            return props
          },
        meta:{
            requireAuth: false
        }
    },
    {
        path: '/radiation/globalupdate',
        name:'Radiation Global Update',
        component: ()=>import('@/components/Radiation/GlobalUpdate.vue'),
        meta:{
            requireAuth:false
        }

    },
    {
        path:'/radiation/radiationprint/:radiationId',
        name: 'Radiation Print',
        component: ()=>import('@/components/Radiation/RadiationPrint.vue'),
        meta: {
            requireAuth:false
        }
    },
    {
        path:'/reports/radiation',
        name:'Radiation Report',
        component:()=>import('@/components/Reports/RadiationReport.vue'),
        meta: {
            requireAuth:false
        }
    },
    {
        path:'/reports/disposalreport',
        name: 'Disposal Report',
        component:()=>import('@/components/Reports/DisposalReport.vue'),
        meta:{
            requireAuth:false
        }
    },
    {
        path:'/reports/leaktestreport',
        name:'Leak Test Report',
        component:()=>import('@/components/Reports/LeakTestReport.vue'),
        meta:{
            requireAuth:false
        }
    },
    {
        path:'/reports/testdropboxinput',
        name: 'Test DropBox Input',
        component:()=>import('@/components/Reports/TestDropBoxInput.vue'),
        meta: {
            requireAuth:false
        }        
    },
    {
        path:'/reports/leaktestreportprint',
        name: 'Leak Test Report To Print',
        component:()=>import('@/components/Reports/LeakTestReportPrint.vue'),
        meta:{
            requireAuth:false
        }
    },
    {
        path: '/reports/radiationShutterChecklist',
        name: 'Radiation Inspection List',
        component: () =>import('@/components/Reports/RadiationShutterCheckList.vue'),
        meta:{
            requireAuth:false
        }
    },
    {
        path:'/users/newuser',
        name: 'Add New User',
        component:()=>import('@/components/users/NewUser.vue'),
        meta:{
            requireAuth:false
        }
    }

]

const router=new VueRouter({
    mode: 'history',routes
})

export default router